import { V3Record } from "data/helpers/V3Record.js";

export const Milestone = V3Record(
  "milestone",
  {
    goalId: null, // int
    title: null, // string
    overview: null, // string
    targetType: null, // string
    targetValue: null, // float
    badge: null, // string
    badgePreset: null, // string
    createdAt: null,
    updatedAt: null,
  },
  {
    writeable: ["goalId", "title", "overview", "targetType", "targetValue", "badge", "badgePreset"],
    fileAttrs: ["badge"],
  }
);
